import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelNameRatingAndAddress } from "./HotelNameRatingAndAddress";
import { NearestLocationContent } from "./NearestLocation/NearestLocationContent";
import { useLocalization } from "@shared-ui/localization-context";
import { Description } from "./Description";
import PriceLockup from "../views/HotelsViews/components/shared/PriceLockup";
import { HotelPriceLockupWithDates } from "../utils/A11y/HotelPriceLockupWithDates";

/**
 * CardContent which contains the overall ratings, pricing, value proposition
 * and guest amount (hard coded)
 */
export const CardContentReviewsPriceProposition = ({
  hotel,
  locale,
  locationName,
  context,
  isViewCarousel,
  showDistance,
  showAddress,
  shouldUseImperialDistanceUnits,
  addressDistanceView,
}: {
  hotel: Hotel;
  locale: string;
  locationName: string;
  context: ExtendedContextStore;
  isViewCarousel?: boolean;
  showDistance?: boolean;
  showAddress?: boolean;
  shouldUseImperialDistanceUnits?: boolean;
  addressDistanceView?: string;
}) => {
  const { formatText, formatDateString } = useLocalization();

  return (
    <>
      {isViewCarousel ? (
        <>
          <div className="uitk-grid">
            <div className="uitk-cell fill">
              <div className="truncate uitk-type-heading-500 uitk-type-bold">{hotel.hotelName}</div>
            </div>
          </div>

          <div className="uitk-grid all-x-gutter-two">
            <div className="uitk-cell fill">
              <HotelNameRatingAndAddress
                hotel={hotel}
                locale={locale}
                context={context}
                isViewCarousel={isViewCarousel}
                showAddress={showAddress}
                showDistance={showDistance}
                locationName={locationName}
                shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
                addressDistanceView={addressDistanceView}
              />
            </div>
            <PriceLockup
              hotel={hotel}
              className="uitk-cell shrink"
              priceA11y={new HotelPriceLockupWithDates(hotel, formatText, formatDateString)}
            />
            <Description hotel={hotel} />
            <NearestLocationContent
              context={context}
              model={hotel.directDistance}
              shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
            />
          </div>
        </>
      ) : (
        <div className="uitk-grid all-x-gutter-two">
          <div className="uitk-cell fill">
            <HotelNameRatingAndAddress
              hotel={hotel}
              locale={locale}
              context={context}
              isViewCarousel={isViewCarousel}
              showAddress={showAddress}
              showDistance={showDistance}
              locationName={locationName}
              shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
              addressDistanceView={addressDistanceView}
            />
          </div>
          <PriceLockup
            hotel={hotel}
            className="uitk-cell shrink"
            priceA11y={new HotelPriceLockupWithDates(hotel, formatText, formatDateString)}
          />
          <Description hotel={hotel} />
          <NearestLocationContent
            context={context}
            model={hotel.directDistance}
            shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
          />
        </div>
      )}
    </>
  );
};
